function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import SelectableTag from "segments/desktop/core-components/selectable-tag/selectable-tag";
import classnames from "classnames";
import { GENERIC_CLUSTER } from "constants/clusters";
import { isDarkTheme } from "segments/segments-service";
import { getUrlParamValueFromCurrentLocation } from "utils/url";
import { setCookie } from "services/cookies-service";
import { IS_IN_CRM_USE_CASES_TEST_VARIANT } from "constants/cookies";
import SelectableTagsGridButtonComponent from "./selectable-tags-grid-button-component/selectable-tags-grid-button-component";
import { updateUserClustersListWithMultipleClusters } from "/services/clusters-service";
import { HP_TAGS_SELECTION } from "/constants/clusters";
import { CLUSTER_TYPE, USE_CASE_TYPE } from "/constants/clusters/types.js";
import { StyledSelectableTagsGrid } from "./selectable-tags-grid.scss";
import DefaultProps from "./default-props";
import { withGenericConfig } from "/contexts/generic-config-context";
import { PRESELECTED_TAG_PARAM_NAME } from "../square-tags/square-tags";
const SelectableTagsGrid = (props)=>{
    const [selectedTags, setSelectedTags] = useState([]);
    const buttonContainer = useRef(null);
    const { onTagToggle, darkMode, gridSelectableTags, clusterId, clusterVariant, useMobileClusterTags, isMobileOrTabletBrowser, sendClustersAsParams, buttonConfig, align, secondaryButtonConfig, youTubeButtonConfig, withSecondaryButton, withYouTubeButton, width, theme, buttonTopMargin, websiteAlignmentBranding, disableAnimation, IsInCrmUseCasesTest } = props;
    const getSelectedTagFromUrl = ()=>{
        const selectedTagId = getUrlParamValueFromCurrentLocation(PRESELECTED_TAG_PARAM_NAME);
        if (!selectedTagId) return;
        return gridSelectableTags.find((cluster)=>cluster.overridePageCluster === selectedTagId || cluster.overridePageSubCluster === selectedTagId);
    };
    useEffect(()=>{
        // pre-select tags that were marked with 'Initially Selected' or taken from URL
        setSelectedTags(gridSelectableTags.filter((tag)=>tag.initiallySelected || tag === getSelectedTagFromUrl()));
        //  Cookie used for CRM use cases ab test only - will be removed after test.
        setCookie(IS_IN_CRM_USE_CASES_TEST_VARIANT, IsInCrmUseCasesTest, {
            expires: 1 // 1 day
        });
    }, []);
    const onSelectableTagClick = (gridSelectableTag, index, isSelected)=>{
        var _buttonContainer_current;
        (_buttonContainer_current = buttonContainer.current) === null || _buttonContainer_current === void 0 ? void 0 : _buttonContainer_current.clickedTag(_object_spread({
            tagIndex: index
        }, gridSelectableTag), isSelected);
        const newSelectedTags = isSelected ? [
            ...selectedTags,
            _object_spread_props(_object_spread({}, gridSelectableTag), {
                index
            })
        ] : selectedTags.filter((s)=>s.index !== index);
        setSelectedTags(newSelectedTags);
        onTagToggle && onTagToggle(newSelectedTags);
    };
    const renderSelectableTags = (gridTag, index)=>{
        const showMobileClusterTags = shouldShowMobileClusterTags();
        const gridSelectableTag = _object_spread_props(_object_spread({}, gridTag), {
            isSelected: selectedTags.find((tag)=>gridTag.tagText === tag.tagText) !== undefined
        });
        return /*#__PURE__*/ _jsx("div", {
            className: classnames("grid-selectable-container", {
                "no-select": showMobileClusterTags
            }),
            children: /*#__PURE__*/ _jsx(SelectableTag, _object_spread_props(_object_spread({}, gridSelectableTag), {
                onClick: (isSelected)=>onSelectableTagClick(gridSelectableTag, index, isSelected),
                showMobileClusterTags: showMobileClusterTags,
                darkMode: darkMode
            }))
        }, index);
    };
    const renderSelectableTagsGrid = ()=>{
        return gridSelectableTags.map(renderSelectableTags);
    };
    const updateClustersBeforeSignup = ()=>{
        let extraParams = {};
        const clustersToUpdate = selectedTags.map((cluster)=>{
            const { tagValue, overridePageCluster: clusterFromTag, overridePageSubCluster: useCaseFromTag } = cluster;
            const useCaseId = useCaseFromTag || tagValue; // tagValue is for old prop support
            const res = [];
            if (clusterFromTag) {
                res.push({
                    clusterId: clusterFromTag,
                    clusterType: CLUSTER_TYPE
                });
            }
            if (useCaseId) {
                const clusterIdToUse = clusterFromTag || clusterId;
                const extraData = clusterIdToUse ? {
                    parent_cluster_id: clusterIdToUse
                } : {};
                res.push({
                    clusterId: useCaseId,
                    clusterType: USE_CASE_TYPE,
                    extraData
                });
            }
            return res;
        });
        if (clustersToUpdate.length === 0 && clusterId) {
            clustersToUpdate.push({
                clusterId,
                clusterType: CLUSTER_TYPE
            }); // if not tags selected use the page cluster
        }
        const flattenedArray = clustersToUpdate.flat();
        if (flattenedArray.length > 0) {
            updateUserClustersListWithMultipleClusters(flattenedArray, HP_TAGS_SELECTION);
            // This is temporarily here because we concat it to the url
            const clusterIds = [
                ...new Set(flattenedArray.map((c)=>c.clusterId).filter((c)=>c !== GENERIC_CLUSTER))
            ];
            extraParams = {
                clusterIds
            };
        }
        return {
            params: _object_spread_props(_object_spread({}, extraParams), {
                clusterVariant
            })
        };
    };
    const shouldShowMobileClusterTags = ()=>{
        return isMobileOrTabletBrowser && useMobileClusterTags;
    };
    const shouldSendClustersAsParams = ()=>{
        return shouldShowMobileClusterTags() && sendClustersAsParams;
    };
    const showMobileClusterTags = shouldShowMobileClusterTags();
    const displayedOnDarkTheme = isDarkTheme(theme);
    const selectableTagsGridButtonInlineStyle = {
        marginTop: buttonTopMargin
    };
    return /*#__PURE__*/ _jsxs(StyledSelectableTagsGrid, {
        className: classnames("selectable-tags-grid", align, {
            "mobile-clusters": showMobileClusterTags
        }),
        style: {
            width: showMobileClusterTags ? "100%" : width
        },
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "selectable-tags-container-wrapper",
                children: renderSelectableTagsGrid()
            }),
            /*#__PURE__*/ _jsx(SelectableTagsGridButtonComponent, {
                ref: buttonContainer,
                disableAnimation: disableAnimation,
                buttonConfig: _object_spread_props(_object_spread({}, buttonConfig), {
                    forceInputHide: true
                }),
                beforeRedirectSyncAction: updateClustersBeforeSignup,
                secondaryButtonConfig: withSecondaryButton && secondaryButtonConfig,
                youTubeButtonConfig: withYouTubeButton && youTubeButtonConfig,
                skipSignupUpdateCluster: true,
                shouldSendClustersAsParams: shouldSendClustersAsParams(),
                displayedOnDarkTheme: displayedOnDarkTheme,
                style: selectableTagsGridButtonInlineStyle,
                websiteAlignmentBranding: websiteAlignmentBranding
            })
        ]
    });
};
export default withGenericConfig(SelectableTagsGrid);
SelectableTagsGrid.defaultProps = DefaultProps;
